import { render, staticRenderFns } from "./smsSettings.vue?vue&type=template&id=20aa1854&"
import script from "./smsSettings.vue?vue&type=script&lang=js&"
export * from "./smsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports